import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const emailsUrl = "/api/v1/OrdersReminderEmailSchedule/OrdersReminderEmail";

export interface OrderReminderApiParameterData extends ApiParameter {
    CustomerId: string;
    EmailReminderforOrders: boolean;
}

export function orderRemiderService(parameter: OrderReminderApiParameterData) {
    return post<any>(`${emailsUrl}`, parameter);
}

// export async function orderRemiderService(parameter: OrderReminderApiParameter) {
//     const model = await post<any>(`${emailsUrl}/${cartId}/true`, orderEmailScheduleModel);
//     return model;
// }
